import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';

@Component({
  selector: 'app-call-notification-modal',
  templateUrl: './call-notification-modal.component.html',
  styleUrls: ['./call-notification-modal.component.css']
})
export class CallNotificationModalComponent implements OnInit, OnDestroy {
  isAccept = false;
  @Input() callDetail;
  @Output() onCloseModal = new EventEmitter<any>()
  user;
  isMinimized = false;
  constructor(private sharedDataService: SharedDataService, private socketService: SocketService) { }


  ngOnInit() {
  }

  accept() {
    console.log("Detail check", this.callDetail);
    this.socketService.emit(Events.DRIVER_CALL, { ...this.callDetail, status: 'accept' });
    if (this.callDetail && this.callDetail.sender && this.callDetail.sender._id) {
      const message = {
        title: '',
        message: "accepted",
        receiver: this.callDetail.sender._id
      };
      this.socketService.emit(Events.DRIVER_ALERT_CALL, message);
    }
    this.isMinimized = false;
    this.onCloseModal.emit({ ...this.callDetail, status: 'accept' });
  }

  reject() {
    const callTo = {
      senderId: this.callDetail.sender._id,
      status: 'decline',
      roomId: this.callDetail.roomId
    };
    this.socketService.emit(Events.DRIVER_CALL, callTo);
    this.callDetail = null;
    this.isMinimized = false;
    this.onCloseModal.emit()
  }

  closeModal() {
    this.onCloseModal.emit()
  }

  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
  }

  ngOnDestroy(): void {
  }

}
